export default () => ({
  amount: '',
  comment: '',
  contract: '',
  category: '',
  continueBilling: '',
  paymentMethod: '',
  paymentForm: '',
  doNotBillTransaction: false
});
